import THAI_JSON from './language-strings/thai.json'
import ENGLISH_JSON from './language-strings/english.json'
import CHINESE_JSON from './language-strings/chinese.json'
import ENGLISH_ERROR_CODE from './language-strings/english-error-code.json'
import THAI_ERROR_CODE from './language-strings/thai-error-code.json'
import CHINESE_ERROR_CODE from './language-strings/chinese-error-code.json'

export const DEFAULT_RESPONSE = {
  data: {
    currencies: [
      {
        id: '63e2e6ef-b67b-42cd-bc26-8e60f4203ad9',
        code: 'USDT',
        is_default: false,
        can_use_for_reg: true,
        supported_languages: [
          {
            language: 'th-TH',
            is_active: true,
            is_default: true
          },
          {
            language: 'en-US',
            is_active: true,
            is_default: false
          },
          {
            language: 'zh-CN',
            is_active: true,
            is_default: false
          }
        ],
        type: 2,
        country_code: 'GO',
        country_name: 'Global',
        website_maintenance: {
          description:
            'The website is under maintenance till further notice, please try again later!!!',
          status: false
        },
        mission_status: true,
        vip_status: 1
      },
      {
        id: '40bdc372-8f10-4351-bde3-c6cab6a44f90',
        code: 'THB',
        is_default: true,
        can_use_for_reg: true,
        supported_languages: [
          {
            language: 'en-US',
            is_active: true,
            is_default: true
          },
          {
            language: 'th-TH',
            is_active: true,
            is_default: false
          }
        ],
        type: 1,
        country_code: 'TH',
        country_name: 'Thailand',
        website_maintenance: {
          description:
            'Are you testing Web Maintence? Test on another currency, we are testing THB payment',
          status: false
        },
        mission_status: true,
        vip_status: 1
      },
      {
        id: '94085457-0f97-4162-94c7-9d65981b5dda',
        code: 'USD',
        is_default: false,
        can_use_for_reg: true,
        supported_languages: [
          {
            language: 'en-US',
            is_active: true,
            is_default: true
          }
        ],
        type: 1,
        country_code: 'US',
        country_name: 'United States',
        website_maintenance: {
          description:
            'The website is under maintenance till further notice, please try again later!',
          status: false
        },
        mission_status: true,
        vip_status: 1
      }
    ],
    recaptcha_status: false
  },
  headers: {
    'x-client-currency': 'THB',
    'x-client-country': 'TH',
    'domain-type': 'main',
    'domain-status': 'true',
    'x-domain-name': 'cslvault.com',
    'x-agent-id': '',
    'x-client-ip': '123.123.123.123',
    'x-agent-type': '',
    'x-player-domain': '',
    'x-floating-icon-domain': ''
  }
}

export const LANGUAGE_STRINGS_ENGLISH = {
  data: ENGLISH_JSON
}

export const LANGUAGE_STRINGS_THAI = {
  data: THAI_JSON
}

export const LANGUAGE_STRINGS_CHINESE = {
  data: CHINESE_JSON
}

export const LANGUAGES = {
  data: [
    {
      language: 'en-US',
      is_active: true,
      is_default: true,
      icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Flag_of_the_United_States.png/1024px-Flag_of_the_United_States.png'
    },
    {
      language: 'th-TH',
      is_active: true,
      is_default: false,
      icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Flag_of_Thailand.svg/2560px-Flag_of_Thailand.svg.png'
    }
  ]
}

export const WEBSITE_SETTINGS = {
  data: {
    id: '40bdc372-8f10-4351-bde3-c6cab6a44f90',
    code: 'THB',
    deposit_min: '1',
    deposit_max: '1000000',
    withdraw_min: '1',
    withdraw_max: '5000000',
    deposit_type: 2,
    reg_flow: 1,
    deposit_verification: 2,
    player_reg_id: 1,
    bank_name_type: 2,
    payment_type_settings: {
      third_party: true,
      bank_transfer: true,
      crypto_currency: true
    },
    website_maintenance: {
      description:
        'Are you testing Web Maintence? Test on another currency, we are testing THB payment',
      status: false
    },
    promo_claim_setting: {
      claim_count: 3
    },
    suspend_reg: false
  }
}

export const CURRENCY_LIST = {
  data: [
    {
      id: '1fa58aac-5904-4df8-ac06-c6f95b4910dd',
      type: 2,
      from_currency: 'MMK',
      to_currency: 'USDT',
      rate: '0.0273',
      reversed_rate: '36.5805',
      is_show_lnd: true,
      is_show_lnd_reverse: true
    },
    {
      id: 'd9222469-4668-4f0a-a3fa-7df991d3656b',
      type: 2,
      from_currency: 'IDR',
      to_currency: 'USDT',
      rate: '0.0273',
      reversed_rate: '36.5805',
      is_show_lnd: true,
      is_show_lnd_reverse: true
    },
    {
      id: 'a9ad4f33-d9ef-4823-98f9-fe782bcf78a5',
      type: 2,
      from_currency: 'VND',
      to_currency: 'USDT',
      rate: '0.0273',
      reversed_rate: '36.5805',
      is_show_lnd: true,
      is_show_lnd_reverse: true
    },
    {
      id: '1f5dcabc-e39c-48eb-b0d8-eb5f7104f1e5',
      type: 2,
      from_currency: 'BRL',
      to_currency: 'USDT',
      rate: '0.0273',
      reversed_rate: '36.5805',
      is_show_lnd: true,
      is_show_lnd_reverse: true
    },
    {
      id: '9347cc09-b4ca-4614-9167-636c74e53c78',
      type: 2,
      from_currency: 'MXN',
      to_currency: 'USDT',
      rate: '0.0273',
      reversed_rate: '36.5805',
      is_show_lnd: true,
      is_show_lnd_reverse: true
    },
    {
      id: '4d4769d3-c2f3-4a39-8f25-1ccdb47a8076',
      type: 2,
      from_currency: 'KHR',
      to_currency: 'USDT',
      rate: '0.0273',
      reversed_rate: '36.5805',
      is_show_lnd: true,
      is_show_lnd_reverse: true
    },
    {
      id: '50bde84f-88b5-423d-b887-e7aa67104d6e',
      type: 2,
      from_currency: 'PHP',
      to_currency: 'USDT',
      rate: '0.0273',
      reversed_rate: '36.5805',
      is_show_lnd: false,
      is_show_lnd_reverse: false
    },
    {
      id: 'a4ae3796-55d2-4725-bdb6-8f153043f032',
      type: 2,
      from_currency: 'THB',
      to_currency: 'USDT',
      rate: '0.02911',
      reversed_rate: '35',
      is_show_lnd: true,
      is_show_lnd_reverse: true
    },
    {
      id: '48a243ca-fcb1-46ae-9ea3-3ed1627ce082',
      type: 2,
      from_currency: 'CNY',
      to_currency: 'USDT',
      rate: '0.141',
      reversed_rate: '7.245',
      is_show_lnd: true,
      is_show_lnd_reverse: true
    },
    {
      id: '3fd2a963-d9f1-4cae-b8fd-1b620aa01cc0',
      type: 2,
      from_currency: 'USD',
      to_currency: 'USDT',
      rate: '1',
      reversed_rate: '1',
      is_show_lnd: true,
      is_show_lnd_reverse: true
    }
  ]
}

export const ERROR_CODES_ENGLISH = {
  data: ENGLISH_ERROR_CODE
}
export const ERROR_CODES_CHINESE = {
  data: CHINESE_ERROR_CODE
}
export const ERROR_CODES_THAI = {
  data: THAI_ERROR_CODE
}

export const SHARE_LINK = {
  data: { domain: 'cslvault.com' }
}

export const PAYMENT_TYPE_MASTER = {
  data: [
    {
      id: 'daf545a6-7d6a-4e24-b510-2a865f5b3c77',
      code: 'third_party',
      name: {
        'en-US': 'Third party',
        'lo-LA': 'Third party',
        'th-TH': 'Third party',
        'vi-VN': 'Third party'
      }
    },
    {
      id: 'ced542cf-d3f5-44bd-a500-674197537d97',
      code: 'crypto',
      name: {
        'en-US': 'Crypto Transfer',
        'lo-LA': 'Crypto Transfer',
        'th-TH': 'Crypto Transfer',
        'vi-VN': 'Crypto Transfer'
      }
    },
    {
      id: 'ba05416d-6be5-4a04-9f90-c28d05e16110',
      code: 'bank_transfer',
      name: {
        'en-US': 'Bank Transfer',
        'lo-LA': 'ໂອນ​ເງິນ​ຜ່ານ​ທະ​ນາ​ຄານ',
        'th-TH': 'โอนเงินผ่านธนาคาร',
        'vi-VN': 'Chuyển khoản ngân hàng',
        'zh-CN': '银行转账'
      }
    }
  ]
}

export const SUPPORTED_LANGUAGES = {
  data: [
    {
      country_code: 'TH',
      country_name: 'Thailand',
      currency_code: 'THB',
      supported_languages: [
        {
          language: 'en-US',
          is_active: true,
          is_default: true
        },
        {
          language: 'th-TH',
          is_active: true,
          is_default: false
        },
        {
          language: 'vi-VN',
          is_active: false,
          is_default: false
        },
        {
          language: 'zh-CN',
          is_active: true,
          is_default: false
        },
        {
          language: 'my-MM',
          is_active: false,
          is_default: false
        }
      ]
    }
  ]
}

export const CRYPTO_CURRENCY_LIST = {
  data: [
    {
      id: '63e2e6ef-b67b-42cd-bc26-8e60f4203ad9',
      code: 'USDT',
      type: 2,
      is_exchange: false,
      name: 'USDT / TRC20',
      is_active: true,
      deposit_min: '3',
      deposit_max: '1000',
      withdraw_min: '3',
      withdraw_max: '1',
      can_use_for_reg: true,
      exchange_to: null,
      symbol: '₮',
      supported_languages: [
        {
          language: 'en-US',
          is_active: true,
          is_default: true
        }
      ]
    }
  ]
}
